import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { ProductInfo } from './components/ProductInfo';
import { Testimonials } from './components/Testimonials';
import { OfferSection } from './components/OfferSection';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    ;
    (function (f: any, b: Document, e: string, v: string, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safely insert script - use head if parentNode is not available
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    (window as any).fbq('init', '1879558579651787');
    (window as any).fbq('track', 'PageView');
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1879558579651787&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <Story data-id="element-4" />
        <ProductInfo data-id="element-5" />
        <Testimonials data-id="element-6" />
        <OfferSection data-id="element-7" />
      </main>
      <FinalCTA data-id="element-8" />
    </div>;
}